import React, { useCallback, useState } from "react";
import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";
import { getUserEmailConfirmedSelector } from "../../../../../app/appSelectors";
import classNames from "classnames";
import { ProfileButtonEmailInfoContainerStyled } from "./styled/ProfileButtonEmailStyled";
import ProfileButtonEmailTitle from "./ProfileButtonEmailTitle";
import ProfileButtonEmailConfirmInfo from "./ProfileButtonEmailConfirmInfo";

function ProfileButtonEmail(props) {
    const {className, userEmailConfirmed} = props;
    const [isShowEmailConfirmedMessage, setIsShowEmailConfirmedMessage] = useState(false);

    const handleStopPropagationClick = useCallback((e) => {
        e.stopPropagation();
    }, []);

    return <ProfileButtonEmailInfoContainerStyled
        onClick={handleStopPropagationClick}
        className={classNames('d-flex flex-column', {
            'bg-gray': !userEmailConfirmed,
            'bg-surface': isShowEmailConfirmedMessage,
        }, className)}
    >
        <ProfileButtonEmailTitle
            isShowEmailConfirmedMessage={isShowEmailConfirmedMessage}
            setIsShowEmailConfirmedMessage={setIsShowEmailConfirmedMessage}
        />
        {!userEmailConfirmed && <ProfileButtonEmailConfirmInfo className="mt-2"/>}
    </ProfileButtonEmailInfoContainerStyled>
}

const mapStateToProps = createStructuredSelector({
    userEmailConfirmed: getUserEmailConfirmedSelector,
});

export default connect(mapStateToProps)(ProfileButtonEmail);
